import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import intl from 'react-intl-universal';
import MoreHoriz from '@material-ui/icons/MoreHoriz';
import Delete from '@material-ui/icons/Delete';
import CloudDownload from '@material-ui/icons/CloudDownload';
import { formatDDMMYY } from 'src/helpers/date.js';
import { formatFileSize, getFileIcon } from 'src/helpers/upload';
import '@mdi/font/css/materialdesignicons.css';
import { ATTACHMENT_TYPES } from 'src/constants/constants';

const components = {
  Delete,
  CloudDownload,
};
const getIcon = id => {
  const DynComp = components[id];

  return <DynComp className="icon sm" />;
};
const UploadViewPres = ({
  attachments,
  showMenu,
  showMenuHandler,
  menuHandler,
  menu,
  selectable,
  onSelected,
  showBorder,
  selectAction,
  deleteSelected,
  deleteEnabled,
  selectedAttachments,
}) => {
  // short term fix till all attachments follow format:
  // {
  //   file: object,
  //   progress: number,
  // }
  let attachmentsWithProgress = attachments;
  if (attachments && attachments.length) {
    //if a file is coming through and not just repopulating fields
    if (attachments[0].hasOwnProperty('file')) {
      attachmentsWithProgress = attachments.map(attachment => {
        if (typeof attachment.progress === 'undefined') {
          return { file: attachment, progress: 0 };
        }
        return attachment;
      });
    }
  }
  return (
    <div className="attach-container">
      {!!selectAction && attachmentsWithProgress.length > 0 && (
        <span
          className={classNames('delete-attachment', {
            enabled: deleteEnabled,
          })}
          onClick={() => {
            if (deleteEnabled) {
              deleteSelected();
            }
          }}>
          {selectAction}
        </span>
      )}
      {attachmentsWithProgress &&
        attachmentsWithProgress.map(({ progress, file, fileName, fileSize, uploadedBy, createdDate }, id) => {
          const nameOfFile = typeof file !== 'undefined' ? file.name : fileName,
            sizeOfFile = typeof file !== 'undefined' ? formatFileSize(file.size) : fileSize;

          return (
            <div className="attach-file" key={id}>
              {!!selectable && (
                <span className="input-container">
                  <input
                    type="checkbox"
                    checked={selectedAttachments.indexOf(id) > -1}
                    className="delete-input"
                    onChange={() => onSelected(id)}
                  />
                </span>
              )}
              <span className={`mdi ${getFileIcon(nameOfFile, ATTACHMENT_TYPES)} file-icon`} />
              {nameOfFile.substring(nameOfFile.lastIndexOf('\\') + 1)}

              <nav className="nav-bar">
                <span className="file-size">{sizeOfFile}</span>
                <nav className="menu-wrapper">
                  <MoreHoriz className="icon lg" onClick={() => showMenuHandler(id)} />
                  {showMenu[`menu${id}`] && (
                    <div className="menu-container">
                      <ul className="menu">
                        {menu &&
                          menu.map((item, j) => (
                            <li key={item.key ? item.key : item} className="menu-item" onClick={() => menuHandler(j, id)}>
                              {getIcon(item.icon)}
                              {item.text}
                            </li>
                          ))}
                      </ul>
                    </div>
                  )}
                </nav>
                {showMenu[`menu${id}`] && <div className="screen" onClick={() => showMenuHandler(id)} />}
              </nav>
              {uploadedBy && (
                <div className="control-file-info">
                  <p className="file-uploaded">
                    {intl.get('documents.uploadedBy', {
                      owner: uploadedBy,
                      date: formatDDMMYY(createdDate),
                    })}
                  </p>
                </div>
              )}
              <div className="upload-progress-bar" style={{ width: `${progress}%` }} />
            </div>
          );
        })}
    </div>
  );
};

UploadViewPres.propTypes = {
  attachments: PropTypes.array,
};

export default UploadViewPres;
